import React, { createContext, useContext, useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '../api/axiosInstance'

const AuthContext = createContext()

export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()

    const setToken = token => {
        setIsAuthenticated(true)
        localStorage.setItem('token', token)
        axios.defaults.headers.common.Authorization = `Bearer ${token}`
    }

    const switchAccount = async accountId => {
        const { data } = await axiosInstance.post('/accounts/switch', {
            account_id: accountId
        })
        setToken(data.token)
        setUser(data.user)
        navigate('/admin/default', { replace: true })
        window.location.reload()
    }

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (token) {
            setIsAuthenticated(true)
            axios.defaults.headers.common.Authorization = `Bearer ${token}`
            getPermissions().then(data => {
                setUser(data)
                if (!data.status) {
                    logout()
                }
            })
        }
        setLoading(false)
    }, [])

    const getPermissions = async () => {
        const response = await axiosInstance.get('/me')
        return response.data
    }

    const login = async (email, password) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/login`,
                { email, password }
            )
            if (!response.data.user?.status) {
                logout()
                return
            }

            const token = response.data.token
            setToken(token)
            setUser(response.data.user)
        } catch (error) {
            console.error('Login failed:', error)
            throw error
        }
    }

    const logout = () => {
        setIsAuthenticated(false)
        setUser(null)
        localStorage.removeItem('token')
        delete axios.defaults.headers.common.Authorization
        navigate('/auth/sign-in')
    }

    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                user,
                login,
                logout,
                loading,
                setToken,
                setUser,
                switchAccount
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}
